const integrations = {
	title: "Integrations",
	stitle: "Integration",
	new_integration: "New Integration",
	edit_integration: "Edit Integration: {name}",
	list_title: "List of Integrations",
	id: "ID",
	tenant_id: "Tenant",
	name: "Name",
	slug: "Tag",
	key: "Key",
	secret: "Secret",
	status: "Status",
	add_integration: "Add Integration",
	update_integration: "Update Integration",
};
export default integrations;